// @flow
import React, { Component } from 'react';
import OfferTemplateContainer from 'containers/offer/OfferTemplateContainer';

type Props = {};

class Offer extends Component<Props> {
  render() {
    return <OfferTemplateContainer />;
  }
}

export default Offer;



// WEBPACK FOOTER //
// ./src/pages/Offer.js